import SureModal from './sure-modal';

export default SureModal;
